import React, { FC } from 'react'

import { Desktop, FiltersButton, TabletOrMobile } from '@avantstay/backoffice-core'

interface OtherFiltersProps {
  activeFiltersLength: number
  isFiltersSidebarOpen: boolean
  onClick: () => void
  children: React.ReactNode
}

export const OtherFilters: FC<OtherFiltersProps> = ({
  children,
  isFiltersSidebarOpen,
  activeFiltersLength,
  onClick,
}) => (
  <>
    <TabletOrMobile>{children}</TabletOrMobile>
    <Desktop>
      <FiltersButton
        isActive={isFiltersSidebarOpen}
        onClick={onClick}
        activeFiltersLength={activeFiltersLength}
      />
    </Desktop>
  </>
)
